export const diagnosticosyTratamientosByPaisQA = {
    "2": { cdiagnos: 300, ctrata: 3 },
    "3": { cdiagnos: 2000, ctrata: 2002 },
    "7": { cdiagnos: 3000, ctrata: 3003 },
    "4": { cdiagnos: 22, ctrata: 4 },
    "10": { cdiagnos: 400, ctrata: 403 },
    "11": { cdiagnos: 110, ctrata: 1 },
    "13": { cdiagnos: 34, ctrata: 3 },
    "14": { cdiagnos: 200, ctrata: 202 },
    "12": { cdiagnos: 28, ctrata: 2 },
    "6": { cdiagnos: 201, ctrata: 2 },
    "15": { cdiagnos: 300, ctrata: 2 }
};

export const diagnosticosyTratamientosByPaisPRD = {
    "2": { cdiagnos: 300, ctrata: 10 },
    "3": { cdiagnos: 2000, ctrata: 2002 },
    "7": { cdiagnos: 3000, ctrata: 3003 },
    "4": { cdiagnos: 22, ctrata: 4 },
    "10": { cdiagnos: 400, ctrata: 403 },
    "11": { cdiagnos: 110, ctrata: 1 },
    "13": { cdiagnos: 34, ctrata: 3 },
    "14": { cdiagnos: 200, ctrata: 202 },
    "12": { cdiagnos: 28, ctrata: 2 },
    "6": { cdiagnos: 201, ctrata: 2 },
    "15": { cdiagnos: 300, ctrata: 2 }
};